import React from 'react';
/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  useGblz,
  a,
  ls,
  f,
  gs,
  BoxC,
  GridC,
  TextC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import * as ht from './_ht';
import * as hf from './_hf';
import * as hfDTM from './_hfDTM';

import * as icvi1z from './icvI1z___Mz';

/*
const _date1 = hfDTM.cvtFdm(hfDTM.getTdy());
const _date2 = hfDTM.addMth(_date1, 1);
const _date3 = hfDTM.addMth(_date1, 2);
const _mth1 = hfDTM.cvtMth(_date1);
const _mth2 = hfDTM.cvtMth(_date2);
const _mth3 = hfDTM.cvtMth(_date3);
*/

let $i1zrCnts = [] as ht.ls;

export const N = (pz: {
  sPz: ht.dz,
  cz: {
    ctt?: 'r' | 'e', // content
    i18r_fst: ht.n,
    sc: ht.s,
    tc: ht.s,
    //date?: ht.s,
    tgtSttDate?: ht.s,
    tgtEndDate?: ht.s,
  },
  boxStlz: ht.boxStlz,
}) => {

  const _frcUdt = ls.frcUdt();
  const _gStgz = gs.useStgz();

//hf.l(`icvI1z___TzCnt 51: ${pz.cz.tgtSttDate}`);
  const _date1 = pz.cz.tgtSttDate ?? hfDTM.cvtFdm(hfDTM.getTdy());
  const _date2 = hfDTM.addMth(_date1, 1);
  const _date3 = hfDTM.addMth(_date1, 2);
  const _date4 = hfDTM.addMth(_date1, 3);
  const _date5 = hfDTM.addMth(_date1, 4);
  const _mth1 = hfDTM.cvtMth(_date1);
  const _mth2 = hfDTM.cvtMth(_date2);
  const _mth3 = hfDTM.cvtMth(_date3);
  const _mth4 = hfDTM.cvtMth(_date4);
  const _mth5 = hfDTM.cvtMth(_date5);

//hf.l(`icvI1z___TzCnt 62: ${pz.cz.tgtSttDate}, ${_date1}`);
  React.useEffect(() => {
    if ( pz.cz.i18r_fst > 0 ) {
      const _i1zrs1100iMnm = pz.cz.ctt == 'e' ? undefined : 80;
      const _i1zrs1200iMnm = pz.cz.ctt == 'e' ? 70 : undefined;
      //hf.l(`icvI1z___TzCnt 66: ${pz.cz.ctt}, ${_i1zrs1100iMnm}, ${_i1zrs1100iMnm}`)
      cmFTH.loadAllAsync({
        frcUdt: _frcUdt,
        bfrAsync: () => [
          icvi1z.loadI1zrLsAsync({
            i18r_fst: pz.cz.i18r_fst,
            i1zrd3100sStt: _date1,
            i1zrs1100iMnm: _i1zrs1100iMnm,
            i1zrs1200iMnm: _i1zrs1200iMnm,
            fld: '*'
          })
          .then( ( _ls: ht.ls ) => {
            $i1zrCnts = hf.agt({ 
//              ls: _ls,
              ls: _ls.filter((_dz: ht.dz) => _dz.i1zrd3100s >= hfDTM.getTdy() ), // 20240307 本日以降のみが集計対象
              keyFldName: 'Fdm',
              grtKey: ( _dz: ht.dz ) => hfDTM.cvtFdm(_dz.i1zrd3100s),
              clts: [
                {
                  mode: 'cnt',
                  vleFldName: 'i1zrCnt', 
                }
              ],
            })
          }),
        ]
      })
    }
    else {
      $i1zrCnts = [];
      _frcUdt();
    }
  }, [
    pz.cz.i18r_fst,
  ])

  const _ls1 = [
    {
      mth: _mth1,
      maxCnt: hf.f(_gStgz.crt.rsvMaxCntz?.[hfDTM.f(_date1, 'YYYY-MM')]) ? _gStgz.crt.rsvMaxCntz?.[hfDTM.f(_date1, 'YYYY-MM')] : '0',
      crtCnt: hf.getDz($i1zrCnts, _date1, 'Fdm')?.i1zrCnt ?? '0',
    },
    {
      mth: _mth2,
      maxCnt: hf.f(_gStgz.crt.rsvMaxCntz?.[hfDTM.f(_date2, 'YYYY-MM')]) ? _gStgz.crt.rsvMaxCntz?.[hfDTM.f(_date2, 'YYYY-MM')] : '0',
      crtCnt: hf.getDz($i1zrCnts, _date2, 'Fdm')?.i1zrCnt ?? '0',
    },
    {
      mth: _mth3,
      maxCnt: hf.f(_gStgz.crt.rsvMaxCntz?.[hfDTM.f(_date3, 'YYYY-MM')]) ? _gStgz.crt.rsvMaxCntz?.[hfDTM.f(_date3, 'YYYY-MM')] : '0',
      crtCnt: hf.getDz($i1zrCnts, _date3, 'Fdm')?.i1zrCnt ?? '0',
    },
  ];
  if (    pz.cz.tgtEndDate && _date4 <= pz.cz.tgtEndDate ) {
    _ls1.push(
      {
        mth: _mth4,
        maxCnt: hf.f(_gStgz.crt.rsvMaxCntz?.[hfDTM.f(_date4, 'YYYY-MM')]) ? _gStgz.crt.rsvMaxCntz?.[hfDTM.f(_date4, 'YYYY-MM')] : '0',
        crtCnt: hf.getDz($i1zrCnts, _date4, 'Fdm')?.i1zrCnt ?? '0',
      }
    )
  }
  if (    pz.cz.tgtEndDate && _date5 <= pz.cz.tgtEndDate ) {
    _ls1.push(
      {
        mth: _mth5,
        maxCnt: hf.f(_gStgz.crt.rsvMaxCntz?.[hfDTM.f(_date5, 'YYYY-MM')]) ? _gStgz.crt.rsvMaxCntz?.[hfDTM.f(_date5, 'YYYY-MM')] : '0',
        crtCnt: hf.getDz($i1zrCnts, _date5, 'Fdm')?.i1zrCnt ?? '0',
      }
    )
  }

  //hf.l(`icvI1z___Tz 134: ${pz.cz.tgtEndDate}`)

  const _ls2 = _ls1.map((_dz1: ht.dz, _idx: ht.n) => (
    cr.c(GridC.N, {
      key: _idx,
      boxStlz: a('bc/lt9 bwt/1 bwr/1 dw/36 mb/1'),
      lineCs: [
        {
          cellCs: [
            { 
              boxStlz: a(`f/1 sc/${pz.cz.sc}`),
              oClds: [
                cr.c(TextC.N, {
                  key: -10,
                  textz: {
                    pfx: `${_dz1.mth}月`,
                    stlz: a(`tc/${pz.cz.tc} tb ta/c`),
                  },
                })
              ]
            },
          ]
        },
        {
          cellCs: [
            { 
              boxStlz: a('f/2 fd/rec sc/rd1'),
              oClds: [
                cr.c(TextC.N, {
                  key: -10,
                  boxStlz: a('ph/1'),
                  textz: {
                    pfx: `${pz.sPz.crt.dffz.tgt}上限数：`,
                    stlz: a('pv/0.5 ta/r tc/lt9'),
                  },
                })
              ]
            },
            { 
              boxStlz: a('sc/rd1 bwl/0 f/1 fd/ccc'),
              oClds: [
                cr.c(TextC.N, {
                  key: -10,
                  textz: {
                    pfx: _dz1.maxCnt,
                    stlz: a('pv/0.5 ta/c tb tc/lt9'),
                  },
                })
              ]
            },
          ]
        },
        {
          cellCs: [
            { 
              boxStlz: a('f/2 fd/rec'),
              oClds: [
                cr.c(TextC.N, {
                  key: -10,
                  boxStlz: a('ph/1'),
                  textz: {
                    pfx: `現在の${pz.sPz.crt.dffz.tgt}件数：`,
                    stlz: a('pv/0.5 tc/lt9'),
                  },
                })
              ]
            },
            { 
              boxStlz: a('f/1 bwl/0 fd/ccc'),
              oClds: [
                cr.c(TextC.N, {
                  key: -10,
                  textz: {
                    pfx: _dz1.crtCnt,
                    stlz: a('pv/0.5 ta/c tb tc/lt9'),
                  },
                })
              ]
            },
          ]
        },
      ]
    })
  ))

  return (
    cr.c(BoxC.N, {
      key: -10,
      boxStlz: {
        ... a('dw/f fd/ras fw'),
        ... pz.boxStlz,
      },
      oClds: _ls2,
    })
  );
};
